/// <reference types="vite/types/importMeta.d.ts" />
declare let self: ServiceWorkerGlobalScope;
export {};

async function register() {
  try {
    const swUrl = import.meta.env.VITE_SW_PATH ?? '/sw.js';
    await navigator.serviceWorker.register(swUrl, {
      scope: '/',
      type: 'module',
    });
    console.log('Registered Service Worker');
  } catch (e) {
    console.log(e.message);
  }
}

if ('serviceWorker' in navigator) {
  const registrations = await navigator.serviceWorker.getRegistrations();
  for (const registration of registrations) {
    console.log('Unregister Service Worker');
    registration.unregister();
  }
  await register();
}
